<template>
    <div  class="tab-pane form-comment" id="questions" role="tabpanel" aria-expanded="false">
        <article id="questionsContainer">
            <h2 class="param-title">
                پرسش و پاسخ
                <span>پرسش خود را در مورد محصول مطرح نمایید</span>
            </h2>
            <form @submit.prevent="addQuestion" class="comment">
                <textarea name="question" v-model="questionInfo.Question" v-validate="{ required: true,max:2000}" data-vv-as="متن پرسش" class="form-control" placeholder="پرسش خود را در مورد محصول مطرح نمایید" rows="3"></textarea>
                <span class="error">{{ errors.first('question') }}</span>
                <div class="parent-btn">
                    <button type="submit" class="dk-btn dk-btn-info">ثبت پرسش</button>
                </div>
            </form>
            <hr v-if="productQuestion.TotalCount > 0" />
            <h2 v-if="productQuestion.TotalCount > 0" class="param-title">
                پرسش کاربران
                <span>{{productQuestion.TotalCount}} پرسش</span>
            </h2>
            <div class="col-12" >
                <div :class="{'loader':!showLoaderQuestion}" style="position:absolute;background-color:#80808033;top:0;bottom:0;left:0;right:0;z-index:9999;width:100%;height:100%">
                    <img style="position:absolute;top:35%;left:40%;z-index:100" src="/assets/img/loader/loader.svg" />
                </div>
                <div class="j-qustion-content" v-for="info in productQuestion.FilteredQuestions">
                    <div class="row">
                        <div class="managment-j col-md-2">
                            <img src="/assets/img/svg/avatar-1.svg" />
                            <span class="title">پاسخ توسط مدیر</span>
                        </div>
                        <div class="col-md-10">
                            <div class="j-qustion-answer">
                                <span class="title-t">سوال </span>
                                <div class="title-date-all"><span> {{info.CustomerName}} </span><span>({{info.RegDateTime}})</span></div>
                                <p v-text="info.Question"></p>
                            </div>
                            <hr />
                            <div class="j-qustion">
                                <span class="title-t">پاسخ </span>
                                <div class="title-date-all"><span> مدیر </span><span>({{info.AnsweredDateTime}})</span></div>
                                <p v-text="info.Answer"></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </article>
        <!--Modal-->
        <div class="modal fade" id="okAddQuestionModal" tabindex="-1" role="dialog" aria-labelledby="reviewModal" aria-hidden="true">
            <div class="modal-dialog" role="alertdialog">
                <div class="modal-content">
                    <div class="modal-header">
                    </div>
                    <div class="modal-body">
                        <div class="row content-main-post">
                            <div class="content-review col-md-12 col-xs-12">
                                <div class="div-img"><img src="/assets/img/check.svg" /></div>
                                <div class="text-succses"><p>پرسش شما ثبت گردید و پس از تأیید در وب سایت نمایش داده خواهد شد.</p></div>
                            </div>
                        </div>
                    </div>
                    <div class="btn-main">
                        <button @click="closeModal" type="button" class="dk-btn dk-btn-success">تأیید</button>
                    </div>
                </div>
            </div>
        </div>
        <!--Modal-->
        <div  id="questionsPaging" class="pager default text-center"></div>
    </div>
</template>
<script>
    import { httpPromise } from "../../module/httpUtility";
    export default {
        data() {
            return {
                questionInfo: {},
                productQuestion: {},
                showLoaderQuestion:false
            }
        },
        watch: {
            isLoadQuestions(newValue, oldValue) {
                if (newValue == true) {
                    this.sendToServer(0);
                }
            }
        },
        //beforeMount: function() {
        //    this.readQuestion();
        //},
        props: {
            isLoadQuestions: {
                type: Boolean,
            },
        },
        methods: {
            addQuestion() {
                this.$validator.validateAll().then(valid => {
                    if (valid) {
                        this.isShowLoader = true;
                        this.questionInfo.ProductId = this.$route.params.productId;
                        httpPromise(this, '/v1/ProductManagement/ProductQuestions/Add', 'post', JSON.stringify(this.questionInfo),
                            response => {
                                toastr.remove();
                                toastr.success(response.data.Message);
                                this.questionInfo = {};
                                $(function () {
                                    $('#okAddQuestionModal').modal({ backdrop: 'static', keyboard: false });
                                    $('#okAddQuestionModal').modal('show');
                                });
                            },
                            response => {
                                toastr.remove();
                                toastr.error(response.data.Message);
                                this.isShowLoader = false;
                            });
                    }
                });
            },
            closeModal() {
                $(function () {
                    $('#okAddQuestionModal').modal('hide');
                }); 
            },
            sendToServer(pageNum) {
                this.showLoaderQuestion = true;
                httpPromise(this, '/v1/ProductManagement/ProductQuestions/Read', 'get', { ProductId: this.$route.params.productId , Page: pageNum },
                    response => {
                        this.productQuestion = response.data.Value;
                        this.createPaging(response.data.Value.TotalCount, response.data.Value.Page);
                        this.showLoaderQuestion = false;
                        this.scrollTop();
                    },
                    response => {
                        this.showLoaderQuestion = false;
                    }
                );
            },
            createPaging(totalDataCount, pageNumber) {
                var component = this; 
                $(function () { 
                    try {
                        $('#questionsPaging').pagination('destroy');
                    } catch  { }
                    var dataSource = [];
                    for (var i = 1; i <= totalDataCount; i++)
                        dataSource.push(i);
                    if (dataSource != null && dataSource.length > 0) {
                        var container = $('#questionsPaging').pagination({
                            dataSource: dataSource,
                            pageSize: 10,
                            pageNumber: pageNumber,
                            classPrefix: 'pager',
                            ulClassName: 'pager-items',
                            activeClassName: 'is-active',
                        });
                        container.addHook('afterPaging', function () {
                            var pageNum = container.pagination('getSelectedPageNum');
                            component.sendToServer(pageNum);
                        });
                    } 
                });
            },
            scrollTop() {
                $(function () {
                    var top = $('#questionsContainer').offset().top;
                    $('html, body').animate({ scrollTop: top }, 800, 'easeInExpo');
                });
            } 
        }
    }
</script>

<style scoped>
    .param-title span {
        font-size: 15px;
        padding-right: 5px;
    }
    .title-date-all {
        color: #c49595;
        margin-top: 5px;
        padding-right: 5px;
    }
    .box-tabs .card-body p {
        margin: 0px 0;
    }
    .title-t {
        font-weight: 700;
        font-size: 17px;
    }
    .custom-select.is-valid, .form-control.is-valid, .was-validated .custom-select:valid, .was-validated .form-control:valid {
        border-color:#c8c8c8;
    }
    .modal-body, .btn-main {
        padding: 25px;
    }

    .btn-main {
        text-align: center;
    }

    .content-review img {
        width: 120px;
    }

    .content-review .div-img {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: 25px;
    }

    .content-review .text-succses {
        text-align: center;
    }

        .content-review .text-succses p {
            font-size: 15px;
        }

    .parent-btn {
        padding:10px;
    }
    .dk-btn {
        color: #fff;
        font-size: 16px;
        padding: 13px 20px;
    }

    .j-qustion-answer p ,.j-qustion p {
        white-space: pre-wrap;
        color: #777;
    }

    .j-qustion-content {
        border: 1px solid #c8c8c8;
        border-radius: 7px;
        padding: 10px;
        margin-top: 25px;
    }

    .managment-j .title {
        margin-top: 10px;
        font-size: 17px;
        font-weight: bold;
    }

    .managment-j {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }
    .j-qustion-answer {
        white-space:pre-wrap;
    }
        @media only screen and (min-width: 0px) and (max-width: 640px) {
            .managment-j .title {
            font-size: 15px;
        }

            .j-qustion-answer p, .j-qustion p {
                font-size: 13px;
            }


    }
</style>